<template>
  <BaseModal ref="BaseModal" @confirm="confirm">
    <div class="history-project-dialog">
      <SearchSetting class="tab-btn" ref="searchSetting" />
      <MatchProject
        class="tab-btn"
        ref="matchProjectRef"
        :customsColumns="columns"
        :getParams="getParams"
      />
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal/index.vue'
import SearchSetting from '../../BigDataSoftware/DataAnalysis/SearchSetting.vue'
import MatchProject from '../../BigDataSoftware/DataAnalysis/MatchProject.vue'

export default {
  name: 'HistoryProjectDialog',
  components: { BaseModal, SearchSetting, MatchProject },
  data() {
    return {
      columns: [
        {
          field: 'check',
          title: '',
          width: 50,
          cellType: 'checkbox',
          multiple: true,
          canEdit: true,
          canModify: true
        },
        { field: 'name', title: '历史工程名称', width: 100 },
        { field: 'engineeringClassifyName', title: '工程类型', width: 100 },
        { field: 'regionName', title: '所在地区', width: 100 },
        // { field: 'measurementUnit', title: '计量单位', width: 100 },
        { field: 'constructionScale', title: '建筑规模', width: 100 },
        { field: 'totalCost', title: '总造价', width: 100 },
        {
          field: 'totalCostIndicator',
          title: '造价指标',
          width: 100
        }
      ]
    }
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 显示弹窗
    show(options = {}) {
      this.options = options
      this.$refs.BaseModal.show({
        title: options.title || '插入历史工程',
        confirmText: '确定',
        width: '1200px'
      })

      setTimeout(this.init)
    },

    init() {
      this.$refs.matchProjectRef.getTableData()
    },

    getParams() {
      return this.$refs.searchSetting.getData()
    },

    confirm(close) {
      const arr = this.$refs.matchProjectRef.tableData
      const res = arr.filter(e => e.check)
      if (!res.length) {
        return this.$message.warning('请选择一条数据')
      }
      this.$emit('confirm', res)
      close()
    }
  }
}
</script>

<style scoped lang="less">
.history-project-dialog {
  display: flex;
  flex-direction: column;
  gap: 10px;
  ::v-deep .match-project {
    height: 250px;
  }
}
</style>
